import FusionCharts from'./../vendors/fc-core/src/constructor';import defaultFeatures from'../features';FusionCharts.addDep(defaultFeatures);export default FusionCharts;


//////////////////
// WEBPACK FOOTER
// ./node_modules/fusioncharts/core/index.js
// module id = null
// module chunks = 